type SeoAttributes = object;
type ChangedSeoAttributes = Record<string, string | null>;

export const normalizeSeoHtml = (value: unknown) => {
  if (typeof value !== "string" || !value) return null;

  const withoutEmptyTags = value
    .replace(/<p><br><\/p>/g, "")
    .replace(/<div><br><\/div>/g, "")
    .trim();

  return withoutEmptyTags.replace(/<[^>]*>/g, "").trim() === "" ? null : value;
};

const normalizeSeoValue = (value: unknown) =>
  value === undefined || value === null || value === "" ? null : value;

export const getChangedSeoAttributes = (
  initial: SeoAttributes | undefined,
  current: SeoAttributes,
  fields: string[],
  normalizers: Record<string, (value: unknown) => unknown> = {},
) =>
  fields.reduce<ChangedSeoAttributes>((changes, field) => {
    const initialValues = initial as Record<string, unknown> | undefined;
    const currentValues = current as Record<string, unknown>;
    const normalize = normalizers[field] ?? normalizeSeoValue;
    const previousValue = normalize(initialValues?.[field]);
    const currentValue = normalize(currentValues[field]);

    if (previousValue !== currentValue) {
      changes[field] = currentValue as string | null;
    }

    return changes;
  }, {});

export const getSeoFieldErrors = (
  error: unknown,
): Record<string, string> => {
  const requestError = error as {
    response?: { data?: any };
    data?: any;
  };
  const responseData = requestError?.response?.data ?? requestError?.data;
  const apiErrors = responseData?.errors ?? responseData?.error?.errors;
  const fieldErrors: Record<string, string> = {};

  if (!Array.isArray(apiErrors)) return fieldErrors;

  apiErrors.forEach((item) => {
    const message =
      typeof item?.message === "string"
        ? item.message
        : typeof item?.code === "string"
          ? item.code
          : undefined;
    const field =
      item?.field ??
      (message?.startsWith("fullDescription") ? "fullDescription" : undefined);

    if (field === "fullDescription" && typeof message === "string") {
      fieldErrors.fullDescription = message;
    }
  });

  return fieldErrors;
};
